import { KuxEventWithParam } from './events';

export class PerformanceEventArgs extends KuxEventWithParam {
  /**
   * The name of the metric that was measured
   */
  // @ts-expect-error TODO Fix
  metric: string;
  /**
   * Value of the metric, typically in seconds
   */
  // @ts-expect-error TODO Fix
  value: number;

  constructor(data: PerformanceEventArgs) {
    super('performance', data as KuxEventWithParam);
    Object.assign(this, data);
  }
}
